import { NO_ORGANIZATION_ERROR_CODE } from "@/lib/auth/NoOrganizationError"
import { resolveLandingDestination } from "@/lib/organization/resolveLandingDestination"
import type { loginAction } from "../actions/login"

export type LoginResultErrorKey = "noOrganization" | "generic"

export type ResolvedLoginResult =
  | { kind: "error"; errorKey: LoginResultErrorKey }
  | { kind: "redirect"; path: string }

export type ResolveLoginResultParams = {
  redirectTo?: string | null
  lastVisitedOrgId: string | null
}

type LoginActionResult = Awaited<ReturnType<typeof loginAction>>

// Shared between LoginForm (email/password + OAuth) and SsoCallbackHandler so
// the branching off `loginAction`'s result lives in one place. Callers map the
// resulting union onto their own UI surface (form-field error vs. inline
// alert).
export const resolveLoginResult = (
  result: LoginActionResult,
  { redirectTo, lastVisitedOrgId }: ResolveLoginResultParams,
): ResolvedLoginResult => {
  if (result?.serverError === NO_ORGANIZATION_ERROR_CODE) {
    return { kind: "error", errorKey: "noOrganization" }
  }
  if (result?.serverError || result?.validationErrors || !result?.data) {
    return { kind: "error", errorKey: "generic" }
  }
  if (!result.data.organizationId) {
    return { kind: "error", errorKey: "noOrganization" }
  }
  return {
    kind: "redirect",
    path: resolveLandingDestination({
      redirectTo,
      lastVisitedOrgId,
      defaultOrgId: result.data.organizationId,
    }),
  }
}
